
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		let body = $("body");
        let win_width = window.innerWidth;
		let desktopMenuBreakpoint = parseInt(
			$(":root").css("--desktop-menu-breakpoint")
		);

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

        /**
         * Carousel - Icon column overlap
         */
        var carousel_style = function () {
            let carouselBlock        = $('.carousel-block');
            let carouselBlockCaption = $('.carousel-caption', carouselBlock);
            let iconColumnBlock      = $('.carousel-block + .icon-columns-block');

            if (body.hasClass('home') && window.innerWidth >= 992) {
                let iconColumnBlockHeight = iconColumnBlock.height();
                carouselBlockCaption.css('padding-bottom', iconColumnBlockHeight + 150);
                iconColumnBlock.css('margin-top', (iconColumnBlockHeight * -1) - 160);
            } else {
                // Clear if we're on smaller screens.
                carouselBlockCaption.css('padding-bottom', '');
                iconColumnBlock.css('margin-top', '');
            }
        }

        // Run once on page load.
        carousel_style();

        $(window).on('resize', function () {
            // The width of the window has changed. Usually, we don't want to change values when the height changes.
            if (win_width !== window.innerWidth) {
                carousel_style();
            }
        })

		/**
		 * Header - Search bar functionality
		 */
		let searchButton = $(".js-header-search-btn");
		let closeButton = $("#close-button");
		let searchBar = $("#search-container");

		// Search click
		$.each(searchButton, function () {
			$(this).on("click", function () {
				searchBar.fadeIn().addClass("show");
			});
		});

		// Close click
		closeButton.on("click", function () {
			searchBar.fadeOut().removeClass("show");
		});

		/**
		 * Change Forgot Password link
		 */
		$('.login-form form a').attr('href', '/client-login/?action=lostpassword');

		/**
		 * Login form - Add placeholders
		 */
		$('.login-form input[type=text]').attr('placeholder', 'Username');
		$('.login-form input[type=password]').attr('placeholder', 'Password');

		/**
		 * Copyright - Display current year
		 */
		let copyrightYear = new Date().getFullYear()
		$( '#copyright-year' ).text( copyrightYear );

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);
		});

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 100 || body.hasClass("search-results") || body.hasClass("error404")) {
			body.addClass("sticky-header");
			$("header").addClass("sticky");
		} else {
			body.removeClass("sticky-header");
			$("header").removeClass("sticky");
		}

        if ( ! body.hasClass("search-results") && ! body.hasClass("error404") ) {
            $(window).scroll(function () {
                if ($(window).scrollTop() > 100) {
                    $("body").addClass("sticky-header");
                    $("header").addClass("sticky");
                } else {
                    $("body").removeClass("sticky-header");
                    $("header").removeClass("sticky");
                }
            });
        }

		/**
		 * Mobile menu
		 */

		$("header .js-mobile-menu-toggle").on("click", function () {
			$("body").toggleClass("no-scroll");
			searchBar.fadeOut().removeClass("show");
		});

		$("#header-navbar-menu-wrapper")
			.find(
				".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu"
			)
			.each(function () {
				if ($(window).width() < desktopMenuBreakpoint) {
					$(this).addClass("mobile-menu-sub-level-panel");

					let subLevelTitleElement = $("<h3>").html(
						$(this).siblings(".nav-link").html().trim()
					);

					$(this).prepend(
						$("<li>")
							.addClass("menu-item sub-level-panel-heading")
							.append(subLevelTitleElement)
					);
				}
			});

		$("#header-navbar-menu-wrapper.navbar-collapse")
			.on("show.bs.collapse", function () {
				let headerBannerHeight = 0;

				$("body > header")
					.children()
					.each(function () {
						headerBannerHeight += $(this).outerHeight();
					});

				if (!$("body > header").hasClass("sticky")) {
					headerBannerHeight +=
						parseInt($("html").css("margin-top")) -
						$("html").scrollTop();
				}

				$(this).css(
					"--mobile-menu-height",
					$(window).outerHeight() - headerBannerHeight + "px"
				);

				$(this)
					.children(".header-navbar-menu-inner-wrap")
					.addClass("curr-level");
			})
			.on("hidden.bs.collapse", function () {
				$(this).find(".curr-level").removeClass("curr-level");

				$(this).find(".show").removeClass("show fade-in");

				$(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

				$(this).find(".js-menu-back-btn").data("depth-level", 0);
			});

		let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(
			".back-btn-wrap"
		);
		let mobileMenuBackBtn =
			mobileMenuBackBtnWrap.children(".js-menu-back-btn");

		mobileMenuBackBtn.data("depth-level", 0);

		mobileMenuBackBtn.on("click", function () {
			$(this).data("depth-level", $(this).data("depth-level") - 1);

			let currentMenuPanel = $("#header-navbar-menu-wrapper").find(
				".mobile-menu-sub-level-panel.curr-level"
			);

			currentMenuPanel
				.parent()
				.closest(".mobile-menu-sub-level-panel")
				.addClass("curr-level");

			currentMenuPanel
				.addClass("fade-out")
				.removeClass("show fade-in curr-level");

			if ($(this).data("depth-level") <= 0) {
				$("#header-navbar-menu-wrapper")
					.find(".header-navbar-menu-inner-wrap")
					.addClass("curr-level");

				$(this)
					.data("depth-level", 0)
					.parent()
					.addClass("fade-out")
					.removeClass("show fade-in");
			}
		});

		$("#header-navbar-menu-wrapper")
			.find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
			.on("click", function (evt) {
				evt.preventDefault();

				$("#header-navbar-menu-wrapper")
					.find(".curr-level")
					.removeClass("curr-level");

				$(this)
					.siblings(".mobile-menu-sub-level-panel")
					.scrollTop(0)
					.removeClass("fade-out")
					.addClass("show fade-in curr-level");

				if (window.innerWidth < 992) {
					if (mobileMenuBackBtn.data("depth-level") === 0) {
						mobileMenuBackBtnWrap
							.removeClass("fade-out")
							.addClass("show fade-in");
					} else {
						$(this)
							.siblings(".mobile-menu-sub-level-panel")
							.css(
								"top",
								$(this)
									.closest(
										".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap"
									)
									.scrollTop()
							);
					}
				}

				mobileMenuBackBtn.data(
					"depth-level",
					mobileMenuBackBtn.data("depth-level") + 1
				);

				return false;
			});
	});
})(jQuery);